import { render, staticRenderFns } from "./editCalcRule.vue?vue&type=template&id=90c2a802&scoped=true"
import script from "./editCalcRule.vue?vue&type=script&lang=js"
export * from "./editCalcRule.vue?vue&type=script&lang=js"
import style0 from "./editCalcRule.vue?vue&type=style&index=0&id=90c2a802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c2a802",
  null
  
)

export default component.exports